import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import const_config from "../../utility/config/const_config";
import { landingAsset } from "../utils/landingAsset";
import "../sass/MottruckLanding.scss";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const hideHeader = const_config.hideHeader.includes(path);
  const [menuOpen, setMenuOpen] = useState(false);
  const [category, setCategory] = useState("shipper");
  const closeTimer = useRef(null);

  useEffect(() => {
    setMenuOpen(false);
  }, [path]);

  if (hideHeader) return null;

  const openMenu = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    setMenuOpen(true);
  };
  const closeMenu = () => {
    if (closeTimer.current) clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setMenuOpen(false), 180);
  };

  const isSolutions =
    path === "/solutions" || path === "/solutions/carrier" || path.startsWith("/solutions");

  const navClass = (active) => `mtk-nav-link${active ? " active" : ""}`;

  return (
    <header className="mtk-site-header">
      <div className="mtk-header-inner">
        <Link to="/" className="mtk-brand">
          <img src={landingAsset("mottruck-logo-lockup.svg")} alt="Mottruck" />
        </Link>

        <nav className="mtk-nav-pill">
          <Link to="/" className={navClass(path === "/")}>
            Home
          </Link>

          <div
            className="mtk-solutions-wrap"
            onMouseEnter={openMenu}
            onMouseLeave={closeMenu}
          >
            <button
              type="button"
              className={navClass(isSolutions)}
              onClick={() => setMenuOpen((v) => !v)}
            >
              Solutions
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>

            {menuOpen && (
              <div className="mtk-solutions-menu">
                <div className="mtk-solutions-panel">
                  <div className="mtk-sol-col">
                    <div className="mtk-sol-label">Solutions</div>
                    <button
                      type="button"
                      className={`mtk-sol-cat${category === "shipper" ? " active" : ""}`}
                      onMouseEnter={() => setCategory("shipper")}
                      onClick={() => navigate("/solutions")}
                    >
                      Shipper
                    </button>
                    <button
                      type="button"
                      className={`mtk-sol-cat${category === "carrier" ? " active" : ""}`}
                      onMouseEnter={() => setCategory("carrier")}
                      onClick={() => navigate("/solutions/carrier")}
                    >
                      Carrier
                    </button>
                  </div>
                  <div>
                    {category === "shipper" ? (
                      <Link to="/solutions" className="mtk-sol-item" onClick={() => setMenuOpen(false)}>
                        <div className="t">Shipper solutions</div>
                        <div className="d">Find carriers or onboard your own.</div>
                      </Link>
                    ) : (
                      <Link to="/solutions/carrier" className="mtk-sol-item" onClick={() => setMenuOpen(false)}>
                        <div className="t">Connect with Shippers</div>
                        <div className="d">Join our network for free.</div>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <Link to="/web_tracking" className={navClass(path === "/web_tracking")}>
            Tracking
          </Link>
          <Link to="/contact" className={navClass(path === "/contact")}>
            Contact
          </Link>
          <Link to="/demo" className={navClass(path === "/demo")}>
            Demo
          </Link>
        </nav>

        <div className="mtk-header-actions">
          <Link to="/user_login" className="mtk-btn-ghost mtk-btn-join">
            Log in
          </Link>
          <Link to="/join" className="mtk-btn-ghost mtk-btn-join">
            Join
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
